/**
 * RentCafe Integration Block
 *
 * Metadata-only injection block that associates a RentCafe property ID
 * with the current property. Used by other components/systems that need
 * the RentCafe ID (floor plans, pricing, etc.).
 *
 * Renders nothing — purely stores the property_id as a content token.
 */

import type { BlockDefinition, BlockProps } from '../../types';
import type { ComponentContentSchema } from '@vibesites/runtime';

function RentCafeIntegrationComponent(_props: BlockProps) {
  return null;
}

const contentSchema: ComponentContentSchema = {
  slot: 'RentCafeIntegration',
  displayName: 'RentCafe Integration',
  tokens: {
    property_id: {
      label: 'RentCafe Property ID',
      type: 'text',
      defaultField: 'custom_rentcafe_property_id',
      suggestedFields: ['custom_rentcafe_property_id'],
      description: 'RentCafe property ID used for floor plans and pricing data.',
      required: true,
    },
  },
};

export const rentcafeIntegrationBlock: BlockDefinition = {
  id: 'rentcafe-integration',
  name: 'RentCafe Integration',
  description: 'Associates a RentCafe property ID for floor plan and pricing data integration.',
  category: 'Integrations',
  placement: 'injection',
  defaultScope: 'template',
  component: RentCafeIntegrationComponent,
  contentSchema,
  tags: ['rentcafe', 'yardi', 'pms', 'integration', 'floorplans'],
};
